/*
 * @Author: YuanYuan
 * @Date: 2024-05-09 10:05:41
 * @LastEditTime: 2026-01-22 14:43:21
 * @Description: 接口拦截器
 */
import i18n from '@/i18n'
import { computedErrorMsg, initToLogin } from '@/utils/base'
const { Message } = window.ELEMENT

const prefix = process.env.VUE_APP_API_PREFIX
const customResUrls = [
  `${prefix}/package/createTestPackage`,
  `${prefix}/domainGroup/download`,
  `${prefix}/payment/cash/pay`,
  `${prefix}/order/orderSubmit`,
  `${prefix}/domain/add`, // 域名管理 - 新增域名
  `${prefix}/domain/delete_batch`, // 域名管理 - 批量删除域名
]

export const responseInterceptorSucceed = response => {
  const { data } = response
  if (customResUrls.includes(response.config.url)) {
    // 自定义返回结果（如二进制流数据，需要自定义错误信息等）
    return data
  } else {
    if (data) {
      if (data.code !== 200) {
        // 登录超时
        if (data.code === 477) {
          Message.warning(i18n.t('common.loginTimeout'))
          initToLogin()
        } else {
          Message.error(computedErrorMsg(data))
        }
      }
    } else {
      Message.error(i18n.t('common.unkonwnError'))
    }
    return data
  }
}

export const responseInterceptorFailed = error => {
  Message.error(i18n.t('common.unkonwnError'), error)
}
